import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { filter, first } from 'rxjs/operators';
import { UserStore } from '@shared/stores/user.store';
import { User } from '@shared/models/users.model';

export const enableCommentsGuard: CanActivateFn = async () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  try {
    // Convert the user signal to an observable
    const user$ = toObservable(userStore.user);

    // Wait for valid user data
    const user = await firstValueFrom(
      user$.pipe(
        filter((user) => validateUserInfo(user)),
        first()
      )
    );

    // Check if comments is enabled
    if (!user.enableComments) {
      router.navigate(['/home']);
      return false;
    }

    return true;
  } catch (error) {
    console.error('Error in user guard:', error);
    router.navigate(['/home']);
    return false;
  }
};

function validateUserInfo(user: User): boolean {
  return !!user && !!user.companyId && user.companyId.length > 0 && !!user.email && user.email.length > 0;
}
